import 'core-js/stable';
import { ResizeObserver } from '@juggle/resize-observer';
import 'regenerator-runtime/runtime';

// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
}
